var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivechatOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.145,
    height: 27.145,
    viewBox: "0 0 27.145 27.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_6_",
    "data-name": "chat (6)",
    transform: "translate(0 -0.007)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29115",
    "data-name": "Group 29115",
    transform: "translate(0 0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29114",
    "data-name": "Group 29114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65303",
    "data-name": "Path 65303",
    d: "M26.953,16.243,25.08,14.058a7.9,7.9,0,0,0,2.064-5.25c0-4.931-4.784-8.8-10.391-8.8-5.7,0-10.338,3.948-10.338,8.8,0,.122,0,.244.01.366C2.631,10.681,0,13.931,0,17.688a8.578,8.578,0,0,0,2.28,5.763L.2,25.833a.8.8,0,0,0,.6,1.319H11.982c.088,0,.367-.051.424-.056a11.893,11.893,0,0,0,6.882-2.922,8.708,8.708,0,0,0,3.03-6.618h4.031A.8.8,0,0,0,26.953,16.243Zm-14.812,9.28c-.07.006-.31.026-.358.039H2.548L3.96,23.947a.8.8,0,0,0-.051-1.1A7.107,7.107,0,0,1,1.59,17.688c0-4.311,4.3-7.82,9.6-7.82,5.262,0,9.543,3.508,9.543,7.82C20.729,21.72,16.974,25.128,12.141,25.522Zm9.994-9.557h0c-.96-4.424-5.548-7.687-10.948-7.687a13.116,13.116,0,0,0-3.179.388C8.1,4.755,11.987,1.6,16.753,1.6c4.853,0,8.8,3.234,8.8,7.21a6.443,6.443,0,0,1-2.1,4.645.8.8,0,0,0-.054,1.092l1.218,1.42Z",
    transform: "translate(0 -0.007)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29117",
    "data-name": "Group 29117",
    transform: "translate(4.824 15.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29116",
    "data-name": "Group 29116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65304",
    "data-name": "Path 65304",
    d: "M92.588,301a1.59,1.59,0,1,0,1.59,1.59A1.592,1.592,0,0,0,92.588,301Z",
    transform: "translate(-90.997 -300.999)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29119",
    "data-name": "Group 29119",
    transform: "translate(9.596 15.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29118",
    "data-name": "Group 29118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65305",
    "data-name": "Path 65305",
    d: "M182.584,301a1.59,1.59,0,1,0,1.59,1.59A1.592,1.592,0,0,0,182.584,301Z",
    transform: "translate(-180.994 -300.999)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29121",
    "data-name": "Group 29121",
    transform: "translate(14.367 15.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29120",
    "data-name": "Group 29120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65306",
    "data-name": "Path 65306",
    d: "M272.581,301a1.59,1.59,0,1,0,1.591,1.59A1.592,1.592,0,0,0,272.581,301Z",
    transform: "translate(-270.991 -300.999)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechatOutlined);
export default __webpack_public_path__ + "static/media/livechat-outlined.66a258894bb6c3b96dcf2ae34d458230.svg";
export { ForwardRef as ReactComponent };